import { Template } from '@/types/template';

export const templates: Template[] = [
  {
    id: 'business-quarterly-review',
    title: 'Business Quarterly Review',
    description: 'Comprehensive quarterly business review with executive summary, key metrics, team updates, and next quarter goals. Perfect for leadership presentations.',
    category: 'business',
    complexity: 'intermediate',
    slideCount: 14,
    thumbnail: '/templates/thumbnails/business-quarterly-review.jpg',
    agents: ['director', 'scripter', 'data-visualizer'],
    featured: true,
    popular: true,
    tags: ['quarterly', 'business', 'metrics', 'review'],
    createdAt: '2025-01-15'
  },
  {
    id: 'sales-pitch-deck',
    title: 'Sales Pitch Deck',
    description: 'Professional sales pitch presentation with problem-solution framework, benefits showcase, pricing options, and compelling call-to-action.',
    category: 'sales',
    complexity: 'intermediate',
    slideCount: 12,
    thumbnail: '/templates/thumbnails/sales-pitch-deck.jpg',
    agents: ['director', 'scripter', 'graphic-artist'],
    popular: true,
    tags: ['sales', 'pitch', 'b2b', 'proposal'],
    createdAt: '2025-01-14'
  },
  {
    id: 'startup-funding-pitch',
    title: 'Startup Funding Pitch (Series A)',
    description: 'Complete investor pitch deck covering problem, solution, market opportunity, traction, team, and funding ask. Optimized for Series A fundraising.',
    category: 'startup',
    complexity: 'advanced',
    slideCount: 15,
    thumbnail: '/templates/thumbnails/startup-funding-pitch.jpg',
    agents: ['director', 'scripter', 'graphic-artist', 'data-visualizer'],
    featured: true,
    new: true,
    tags: ['startup', 'fundraising', 'investor', 'series-a', 'pitch'],
    createdAt: '2025-01-16'
  },
  {
    id: 'marketing-campaign-proposal',
    title: 'Marketing Campaign Proposal',
    description: 'Strategic marketing campaign proposal with goals, target audience analysis, channel strategy, budget breakdown, and success metrics.',
    category: 'marketing',
    complexity: 'intermediate',
    slideCount: 13,
    thumbnail: '/templates/thumbnails/marketing-campaign-proposal.jpg',
    agents: ['director', 'scripter', 'data-visualizer'],
    tags: ['marketing', 'campaign', 'strategy', 'proposal'],
    createdAt: '2025-01-13'
  },
  {
    id: 'product-launch-plan',
    title: 'Product Launch Plan',
    description: 'Comprehensive product launch presentation covering product overview, go-to-market strategy, timeline, budget, and success metrics.',
    category: 'startup',
    complexity: 'advanced',
    slideCount: 16,
    thumbnail: '/templates/thumbnails/product-launch-plan.jpg',
    agents: ['director', 'scripter', 'graphic-artist', 'data-visualizer'],
    popular: true,
    tags: ['product', 'launch', 'gtm', 'strategy'],
    createdAt: '2025-01-12'
  },
  {
    id: 'educational-course-deck',
    title: 'Educational Course Deck',
    description: 'Engaging educational presentation with clear learning objectives, content modules, interactive activities, and assessment guidelines.',
    category: 'education',
    complexity: 'basic',
    slideCount: 18,
    thumbnail: '/templates/thumbnails/educational-course-deck.jpg',
    agents: ['scripter', 'graphic-artist'],
    tags: ['education', 'teaching', 'course', 'training'],
    createdAt: '2025-01-11'
  },
  {
    id: 'company-overview',
    title: 'Company Overview',
    description: 'Professional company overview presentation showcasing mission, vision, history, team, products, and services. Ideal for partnerships and new client introductions.',
    category: 'business',
    complexity: 'basic',
    slideCount: 10,
    thumbnail: '/templates/thumbnails/company-overview.jpg',
    agents: ['director', 'scripter', 'graphic-artist'],
    tags: ['company', 'overview', 'introduction', 'about'],
    createdAt: '2025-01-10'
  },
  {
    id: 'data-analysis-report',
    title: 'Data Analysis Report',
    description: 'Comprehensive data analysis presentation with data overview, insights, trends, visualizations, and actionable recommendations.',
    category: 'business',
    complexity: 'advanced',
    slideCount: 12,
    thumbnail: '/templates/thumbnails/data-analysis-report.jpg',
    agents: ['director', 'scripter', 'data-visualizer'],
    featured: true,
    tags: ['data', 'analysis', 'insights', 'metrics'],
    createdAt: '2025-01-09'
  },
  {
    id: 'creative-portfolio',
    title: 'Creative Portfolio',
    description: 'Stunning creative portfolio presentation to showcase your work, process, achievements, and client testimonials. Perfect for designers and agencies.',
    category: 'creative',
    complexity: 'intermediate',
    slideCount: 11,
    thumbnail: '/templates/thumbnails/creative-portfolio.jpg',
    agents: ['director', 'graphic-artist'],
    new: true,
    tags: ['portfolio', 'creative', 'design', 'showcase'],
    createdAt: '2025-01-17'
  },
  {
    id: 'training-workshop',
    title: 'Training Workshop',
    description: 'Interactive training workshop presentation with agenda, learning content, practical exercises, resources, and Q&A section.',
    category: 'education',
    complexity: 'intermediate',
    slideCount: 14,
    thumbnail: '/templates/thumbnails/training-workshop.jpg',
    agents: ['director', 'scripter', 'graphic-artist', 'data-visualizer'],
    tags: ['training', 'workshop', 'learning', 'development'],
    createdAt: '2025-01-08'
  },
  {
    id: 'project-status-report',
    title: 'Project Status Report',
    description: 'Detailed project status update with timeline, milestones achieved, current blockers, next steps, and budget tracking.',
    category: 'business',
    complexity: 'intermediate',
    slideCount: 11,
    thumbnail: '/templates/thumbnails/project-status-report.jpg',
    agents: ['director', 'scripter', 'data-visualizer'],
    tags: ['project', 'status', 'update', 'management'],
    createdAt: '2025-01-07'
  },
  {
    id: 'customer-case-study',
    title: 'Customer Case Study',
    description: 'Compelling customer success story highlighting the challenge, your solution, measurable results, and powerful testimonials.',
    category: 'sales',
    complexity: 'basic',
    slideCount: 9,
    thumbnail: '/templates/thumbnails/customer-case-study.jpg',
    agents: ['scripter', 'graphic-artist', 'data-visualizer'],
    tags: ['case-study', 'customer', 'success', 'testimonial'],
    createdAt: '2025-01-06'
  },
  {
    id: 'strategic-planning',
    title: 'Strategic Planning Deck',
    description: 'Executive-level strategic planning presentation with market analysis, competitive landscape, strategic initiatives, roadmap, and KPIs.',
    category: 'business',
    complexity: 'advanced',
    slideCount: 17,
    thumbnail: '/templates/thumbnails/strategic-planning.jpg',
    agents: ['director', 'scripter', 'graphic-artist', 'data-visualizer'],
    featured: true,
    tags: ['strategy', 'planning', 'executive', 'roadmap'],
    createdAt: '2025-01-05'
  },
  {
    id: 'event-presentation',
    title: 'Event Presentation',
    description: 'Engaging event presentation covering event overview, schedule, speakers, logistics, and call-to-action for attendees.',
    category: 'creative',
    complexity: 'basic',
    slideCount: 8,
    thumbnail: '/templates/thumbnails/event-presentation.jpg',
    agents: ['director', 'scripter', 'graphic-artist'],
    tags: ['event', 'conference', 'webinar', 'schedule'],
    createdAt: '2025-01-04'
  },
  {
    id: 'team-onboarding',
    title: 'Team Onboarding',
    description: 'Comprehensive team onboarding presentation with company culture, team introductions, processes, tools, and first-week expectations.',
    category: 'business',
    complexity: 'basic',
    slideCount: 12,
    thumbnail: '/templates/thumbnails/team-onboarding.jpg',
    agents: ['director', 'scripter', 'graphic-artist'],
    popular: true,
    tags: ['onboarding', 'hr', 'team', 'welcome'],
    createdAt: '2025-01-03'
  }
];

export const templateCategories = [
  { value: 'business', label: 'Business', count: templates.filter(t => t.category === 'business').length },
  { value: 'sales', label: 'Sales', count: templates.filter(t => t.category === 'sales').length },
  { value: 'marketing', label: 'Marketing', count: templates.filter(t => t.category === 'marketing').length },
  { value: 'startup', label: 'Startup', count: templates.filter(t => t.category === 'startup').length },
  { value: 'education', label: 'Education', count: templates.filter(t => t.category === 'education').length },
  { value: 'creative', label: 'Creative', count: templates.filter(t => t.category === 'creative').length },
];
